/**
 * Generated runtime TestId mirror for frontend/src/pages/BackgroundJobsDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const BackgroundJobsDashboardTestIds = {
  allHealthy: "all-healthy",
  backgroundJobsDashboardPage: "background-jobs-dashboard-page",
  cardTitleNeedsAttention: "card-title-needs-attention",
  cardTitleRecentExecutions: "card-title-recent-executions",
  cardTitleSourceBreakdown: "card-title-source-breakdown",
  linkViewAllExecutions: "link-view-all-executions",
  needsAttention: "needs-attention",
  recentExecutions: "recent-executions",
  sourceBreakdown: "source-breakdown",
  statAvgDuration: "stat-avg-duration",
  statFailed24h: "stat-failed-24h",
  statRunningNow: "stat-running-now",
  statTotalJobs: "stat-total-jobs",
  recentExec: (exec_id: string) => `recent-exec-${exec_id}`,
  recentExecPrefix: () => "recent-exec-" as TestIdPrefix,
  attentionItem: (index: number) => `attention-item-${index}`,
  attentionItemPrefix: () => "attention-item-" as TestIdPrefix
} as const;
